import type { TenantTheme } from '../types';

/** 锡澄智造谷 — 白标 demo（见 docs/prototypes/whitelabel-xicheng.html）。 */
export const xichengTheme: TenantTheme = {
  code: 'xicheng',
  displayName: '锡澄智造谷',
  logoChar: '锡',
  tagline: '智造未来 · 共生共长',
  colorPrimary: '#1D9E75',
  colorPrimaryAccent: '#0E5A42',
  colorAccentGold: '#E08A1E',
  heroGradient: ['#0C3D33', '#135249', '#1D9E75'],
  honeycombServices: [
    { icon: 'stethoscope', label: '智造诊断' },
    { icon: 'flask', label: '中试服务', variant: 'green' },
    { icon: 'truck-delivery', label: '供应链' },
    { icon: 'settings-cog', label: '设备共享' },
    { icon: 'certificate', label: '科技申报', variant: 'gold' },
    { icon: 'coin', label: '投融资', variant: 'gold' },
  ],
};
